import type { ThemeV3 } from '../types/themeTypes';

/** Neutral light surfaces with white controls and the shared Macro blue accent. */
export const macroLightTheme = {
  id: 'Macro Light',
  name: 'Atlas Light',
  version: 3,
  mode: 'light',
  colorTokens: {
    'surface-0': '#f5f5f5',
    'surface-1': '#fcfcfc',
    'surface-2': '#ffffff',
    'surface-3': '#ffffff',
    'surface-4': '#ffffff',
    'content-0': 'oklch(0.16 0 59deg)',
    'content-1': '#2e2e2e',
    'content-2': 'oklch(0.45 0 59deg)',
    'content-3': 'oklch(0.55 0 59deg)',
    'content-4': 'oklch(0.7 0 59deg)',
    edge: '#e4e4e4',
    'edge-muted': '#ededed',
    'edge-frame': 'var(--color-edge)',
    'edge-button': 'var(--color-edge-muted)',
    accent: 'oklch(0.7 0.12 250deg)',
    red: 'oklch(63.7% 0.237 25.331)',
    orange: 'oklch(70.5% 0.213 47.604)',
    amber: 'oklch(76.9% 0.188 70.08)',
    yellow: 'oklch(79.5% 0.184 86.047)',
    lime: 'oklch(76.8% 0.233 130.85)',
    green: 'oklch(72.3% 0.219 149.579)',
    teal: 'oklch(71.05% 0.1276 181.6)',
    cyan: 'oklch(79.06% 0.1438 215.2)',
    blue: 'oklch(62.3% 0.214 259.815)',
    violet: 'oklch(60.6% 0.25 292.717)',
    purple: 'oklch(62.7% 0.265 303.9)',
    pink: 'oklch(65.6% 0.241 354.308)',
    surface: 'var(--layer-surface)',
    inset: 'var(--layer-inset)',
    ink: 'var(--color-content-0)',
    'ink-muted': 'var(--color-content-1)',
    'ink-subtle': 'var(--color-content-2)',
    'ink-disabled': 'var(--color-content-3)',
    'ink-placeholder': 'var(--color-content-4)',
    link: 'var(--color-accent)',
    'link-hover': 'var(--color-accent)',
    'link-visited': 'var(--color-accent)',
    page: 'var(--color-surface-0)',
    panel: 'var(--color-surface-1)',
    dialog: 'var(--color-surface-2)',
    menu: 'var(--color-surface-2)',
    tooltip: 'var(--color-surface-2)',
    toast: 'var(--color-surface-2)',
    input: 'var(--color-control)',
    'input-focus': 'var(--color-control)',
    message: 'var(--color-surface-1)',
    hover: 'color-mix(in oklch, var(--color-content-0) 3%, transparent)',
    active: 'color-mix(in oklch, var(--color-content-0) 6%, transparent)',
    selected: 'color-mix(in oklch, var(--color-accent) 8%, transparent)',
    success: 'var(--color-green)',
    warning: 'var(--color-yellow)',
    failure: 'var(--color-red)',
    chrome:
      'color-mix(in oklch, var(--color-surface-3) 98%, var(--color-content-0))',
  },
} satisfies ThemeV3;
